<template>
  <printBase ref="LinkQR005" :title='title' :width='800'>
    <div slot="content"  class="printLinkQR">
      <div class="printTitle">首次供货企业审批表</div>
      <div>
        <span class="indentationLeft">企业编号：{{ printInfo.supplierStore.code }}</span>
        <span class="minPrintTitle">{{ printInfo.supplierStore.createTime}}</span>
      </div>
      <table style="width: 100%" class='printContent' border='1' cellspacing="0">
        <tr height='60'>
          <td style="width: 9%"><span>供货企业名称</span></td>
          <td colspan="4" style="width: 26%"><span>{{ printInfo.supplierStore.name }}</span></td>
          <td colspan="2"><span>注册地址</span></td>
          <td colspan="8" style="width: 35%"><span>{{ printInfo.supplierStore.rigistryAddress }}</span></td>
          <td style="width: 5%"><span>邮编</span></td>
          <td colspan="2" style="width: 12%"><span>{{ printInfo.supplierStore.postCode }}</span></td>
        </tr>
        <tr height='30'>
          <td><span>法人代表</span></td>
          <td colspan="2" style="width: 13%"><span>{{ printInfo.supplierStore.corporationPerson }}</span></td>
          <td colspan="3" style="width: 18%"><span>法人委托书有效期</span></td>
          <td colspan="4"><span>{{ printInfo.supplierStore.authorizerEffecivePeroid }}</span></td>
          <td colspan="5"><span>质量保证协议有效期</span></td>
          <td colspan="3"><span>{{ printInfo.supplierStore.qualityEnsureEffecivePeroid }}</span></td>
        </tr>
        <tr height='30'>
          <td rowspan="2"><span>证照编号及有效期</span></td>
          <td rowspan="2" style="width: 8%"><span>营业执照</span></td>
          <td colspan="6" class='alignLeft'><span>信用代码：{{ printInfo.supplierStore.socialUnifyCreditCode }}</span></td>
          <td rowspan="2" colspan="5"><span>药品生产/经营许可证</span></td>
          <td colspan="5" class='alignLeft'><span>证号：{{ printInfo.supplierStore.drugProductCredentailCode }}</span></td>
        </tr>
        <tr height='30'>
          <td colspan="6" class='alignLeft'><span>有效期：{{ printInfo.supplierStore.businessLicenceEffecivePeroid }}</span></td>
          <td colspan="5" class='alignLeft'><span>有效期：{{ printInfo.supplierStore.drugProductEffecivePeroid }}</span></td>
        </tr>
        <tr height='60'>
          <td><span>生产或经营范围</span></td>
          <td colspan="17" class='alignLeft'>
            <span v-if='printInfo.supplierStore.drugProdScopes'>药品生产范围：{{ printInfo.supplierStore.drugProdScopes }}<br></span>
            <span v-if='printInfo.supplierStore.drugBizScopes'>药品经营范围：{{ printInfo.supplierStore.drugBizScopes }}<br></span>
            <span v-if='printInfo.supplierStore.equipmentProdScopes'>器械生产范围：{{ printInfo.supplierStore.equipmentProdScopes}}</span>
            <span v-if='printInfo.supplierStore.equipmentBizScopes'>器械经营范围：{{ printInfo.supplierStore.equipmentBizScopes }}<br></span>
          </td>
        </tr>
        <tr height='30'>
          <td><span>开户行</span></td>
          <td colspan="6"><span>{{ printInfo.supplierStore.depositBank }}</span></td>
          <td colspan="4" style="width:14%"><span>质管部联系人及电话</span></td>
          <td colspan="7"><span></span></td>
        </tr>
        <tr height='30'>
          <td><span>账号</span></td>
          <td colspan="6"><span>{{ printInfo.supplierStore.bankAccount }}</span></td>
          <td colspan="4"><span>税号</span></td>
          <td colspan="7"><span>{{ printInfo.supplierStore.socialUnifyCreditCode }}</span></td>
        </tr>
        <tr height='30'>
          <td><span>电话</span></td>
          <td colspan="6"><span>{{ printInfo.supplierStore.phone }}</span></td>
          <td colspan="4"><span>传真</span></td>
          <td colspan="7"><span>{{ printInfo.supplierStore.fax }}</span></td>
        </tr>
        <tr height='60'>
          <td><span>销售人员姓名</span></td>
          <td colspan="2"><span>{{ printInfo.supplierStore.depositaryName }}</span></td>
          <td colspan="2"><span>身份证</span></td>
          <td colspan="6"><span>{{ printInfo.supplierStore.depositaryIdCard }}</span></td>
          <td colspan="3"><span>联系电话</span></td>
          <td colspan="4"><span></span></td>
        </tr>
        <tr height='30'>
          <td rowspan="3"><span>首营企业审核资料</span></td>
          <td rowspan="3" colspan="6" class='alignLeft'>
              <span>□《药品生产许可证》或其他生产证明文件复印件</span><br/>
              <span>□《药品经营许可证》或其他经营资质证明文件复印件</span><br/>
              <span>□《营业执照》复印件及企业年度报告</span><br/>
              <span>□《GMP认证证书》复印件</span><br/>
              <span>□《GSP认证证书》复印件</span><br/>
              <span>□企业质量保证体系调查表</span><br/>
              <span>□供货方法人委托书原件（明确授权范围和期限）</span><br/>
              <span>□供货方法人委托销售人员身份证复印件</span><br/>
              <span>□随货同行单及发票（票据样式原件）</span><br/>
              <span>□开户银行、开户户名及账号</span><br/>
              <span>□质量保证协议原件（加盖法人章）</span><br/>
              <span>□企业印章模板（红色原印章</span><br/>
              <span>以上证明文件复印件需加盖供货企业公章原印章相应资料符合要求的在对应</span>□内划“√”
          </td>
          <td rowspan="2" colspan="2" style="width:7%"><span>GSP/ GMP证书</span></td>
          <td colspan="3"><span>编号</span></td>
          <td colspan="4"><span>认证范围</span></td>
          <td colspan="2" style="width:9%"><span>有效期</span></td>
        </tr>
        <tr height='60'>
          <td colspan="3"><span>{{ printInfo.supplierStore.gspCode ? printInfo.supplierStore.gspCode : printInfo.supplierStore.gmpCode }}</span></td>
          <td colspan="4"><span></span></td>
          <td colspan="2"><span>{{ printInfo.supplierStore.gspCode ? printInfo.supplierStore.gspEffecivePeroid : printInfo.supplierStore.gmpEffecivePeroid }}</span></td>
        </tr>
        <tr>
          <td colspan="11" class="alignNone">
              <span class="leftTop">备注：</span>
          </td>
        </tr>
        <tr height='70'>
          <td><span>采购员意见</span></td>
          <td colspan="17" class="alignNone">
            <div class="signOpinion">同意</div>
            <div class="rightBottom">
              <span class="indentationRight">签名：{{ printInfo.node1.modifiedUserName }}</span>
              <span v-if='printInfo.node1.modifiedTime'>{{ printInfo.node1.modifiedTime }}</span>
                <template v-else>
                  <span style="margin-right:18px;">年</span>
                  <span style="margin-right:18px;">月</span>
                  <span>日</span>
                </template>
            </div>
          </td>
        </tr>
        <tr height='70'>
          <td><span>质量信誉考察</span></td>
          <td colspan="17" class="alignNone">
            <div class="signOpinion">{{printInfo.supplierStore.qualityOpinionName}}</div>
              <div class="rightBottom">
                <span class="indentationRight">签名：{{ printInfo.node2.modifiedUserName }}</span>
                <span v-if='printInfo.node2.modifiedTime'>{{ printInfo.node2.modifiedTime }}</span>
                <template v-else>
                  <span style="margin-right:18px;">年</span>
                  <span style="margin-right:18px;">月</span>
                  <span>日</span>
                </template>
              </div>
          </td>
        </tr>
        <tr height='70'>
          <td><span>质量负责人意见</span></td>
          <td colspan="17" class="alignNone">
              <div class="signOpinion">{{ printInfo.node2.idea }}</div>
              <div class="rightBottom">
                <span class="indentationRight">签名：{{ printInfo.node2.modifiedUserName }}</span>
                <span v-if='printInfo.node2.modifiedTime'>{{ printInfo.node2.modifiedTime }}</span>
                <template v-else>
                  <span style="margin-right:18px;">年</span>
                  <span style="margin-right:18px;">月</span>
                  <span>日</span>
                </template>
              </div>
          </td>
        </tr>
        <tr height='70'>
          <td><span>企业负责人意见</span></td>
          <td colspan="17" class="alignNone">
              <div class="signOpinion">{{ printInfo.node3.idea }}</div>
              <div class="rightBottom">
                <span class="indentationRight">签名：{{ printInfo.node3.modifiedUserName }}</span>
                <span v-if='printInfo.node3.modifiedTime'>{{ printInfo.node3.modifiedTime }}</span>
                <template v-else>
                  <span style="margin-right:18px;">年</span>
                  <span style="margin-right:18px;">月</span>
                  <span>日</span>
                </template>
              </div>
          </td>
        </tr>
      </table>
    </div>
  </printBase>
</template>
<script>
import printBase from './printBase';
import supplier from '../../services/supplier';
import utils from '../../libs/utils';

export default {
  props: {
    value: {
      type: Object,
    },
  },
  watch: {
    value: {
      handler() {},
      deep: true,
    },
  },
  data() {
    return {
      title: 'Link-QR-005',
      id: 'LinkQR005',
      printInfo: {
        supplierStore: {},
        node1: {
          idea: '',
          modifiedTime: '',
        },
        node2: {
          idea: '',
          modifiedTime: '',
        },
        node3: {
          idea: '',
          modifiedTime: '',
        },
      },
    };
  },
  components: {
    printBase,
  },
  methods: {
    handlePrint(id) {
      supplier.getSupplierStorePrintInfo({ id }).then((res) => {
        if (res.data.status === 200) {
          const { data } = res.data;
          console.log(data);
          data.node1 = {
            idea: '',
            modifiedTime: '',
          };
          data.node2 = {
            idea: '',
            modifiedTime: '',
          };
          data.node3 = {
            idea: '',
            modifiedTime: '',
          };
          if (data.supplierStore) {
            data.supplierStore.authorizerEffecivePeroid = utils.formatTime(data.supplierStore.authorizerEffecivePeroid, 'YYYY/MM/DD');
            data.supplierStore.qualityEnsureEffecivePeroid = utils.formatTime(data.supplierStore.qualityEnsureEffecivePeroid, 'YYYY/MM/DD');
            data.supplierStore.businessLicenceEffecivePeroid = utils.formatTime(data.supplierStore.businessLicenceEffecivePeroid, 'YYYY/MM/DD');
            data.supplierStore.drugProductEffecivePeroid = utils.formatTime(data.supplierStore.drugProductEffecivePeroid, 'YYYY/MM/DD');
            data.supplierStore.drugProductRange = utils.formatTime(data.supplierStore.drugProductRange, 'YYYY/MM/DD');
            data.supplierStore.gspEffecivePeroid = utils.formatTime(data.supplierStore.gspEffecivePeroid, 'YYYY/MM/DD');
            data.supplierStore.gmpEffecivePeroid = utils.formatTime(data.supplierStore.gmpEffecivePeroid, 'YYYY/MM/DD');
            data.supplierStore.createTime = utils.formatTime(data.supplierStore.createTime, 'YYYY年MM月DD日');
          }
          data.workRecordList.forEach((item) => {
            if (item.roleId === 2) {
              data.node1.modifiedUserName = item.createUserName ? item.createUserName : '';
              if (item.createTime) {
                data.node1.modifiedTime = utils.formatTime(item.createTime, 'YYYY年MM月DD日');
              }
              data.node2.idea = item.idea ? item.idea : '';
              data.node2.modifiedUserName = item.modifiedUserName ? item.modifiedUserName : '';
              if (item.modifiedTime) {
                data.node2.modifiedTime = utils.formatTime(item.modifiedTime, 'YYYY年MM月DD日');
              }
            }
            if (item.roleId === 1) {
              data.node1.modifiedUserName = item.createUserName ? item.createUserName : '';
              if (item.createTime) {
                data.node1.modifiedTime = utils.formatTime(item.createTime, 'YYYY年MM月DD日');
              }
              data.node3.idea = item.idea ? item.idea : '';
              data.node3.modifiedUserName = item.modifiedUserName ? item.modifiedUserName : '';
              if (item.modifiedTime) {
                data.node3.modifiedTime = utils.formatTime(item.modifiedTime, 'YYYY年MM月DD日');
              }
            }
          });
          this.printInfo = data;
          this.$nextTick(() => {
            this.$refs.LinkQR005.handlePrint();
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
};
</script>
<style lang="less" scoped>
.printContent td,th{
    text-align: center;
    position: relative;
    border-color: #000;
    font-weight: 300;
    word-break: break-all;
    padding: 2px 6px;
    font-size: 12px;
    *{
      display: inline-block;
      max-height: 50px;
      overflow:hidden
    }

  }
</style>
